<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4"
    v-if="!hydrated">
    <NuxtImg src="/images/App-Logo.png" alt="App Logo" />
  </div>
  <div v-else>
    <Header />
    <NuxtRouteAnnouncer />
    <UContainer>
      <NuxtPage />
    </UContainer>
  </div>
</template>
<script setup lang="ts">
const hydrated = ref(false)
onMounted(() => {
  hydrated.value = true;
})
</script>